import React from "react"
import PropTypes from "prop-types"
import {isEmpty} from "lodash"

import {Hr} from "@irati/ui/src/Layout"
import {FormattedMessage} from "@irati/utils/lang"
import ExpandingList from "@irati/ui/src/ExpandingList"
import {H4} from "@irati/ui/src/Typography"

const FAQ = ({deal}) => {
  const {frequentlyAskedQuestions} = deal
  if (isEmpty(frequentlyAskedQuestions)) return null

  const faqListItems = frequentlyAskedQuestions
    .map((faq) => { return {title: faq.question, description: faq.answer} })

  return (
    <section data-test="faq">
      <Hr large />
      <H4 marginBottom={3}><FormattedMessage id="perks.components.dealInfoBlock.faq.header" /></H4>
      <ExpandingList items={faqListItems} />
      <br />
    </section>)
}

FAQ.propTypes = {
  deal: PropTypes.shape({
    frequentlyAskedQuestions: PropTypes.array
  }).isRequired
}
export default FAQ
